import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';
import { CancelFirmInstructionsQuery } from '../../Models/Models/Company/CancelFirmInstructionsQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class FirmInstructionCancelClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: CancelFirmInstructionsQuery): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/FirmInstructionCancel/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
}

